module.exports = __webpack_public_path__ + "brandon_med-webfont.70732923b969be3a82e5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_med-webfont.woff2
// module id = 944
// module chunks = 7